<script setup>
import { ref, computed } from 'vue';
import { useStore } from 'vuex';
import { checkLogin, LoginResult } from 'JIX/utils/login.js';
import T from './EvaluationsCompanyprofile.i18n.js';

import 'icons/tooltip.svg';

import CompanyRatingComment from 'JIX/components/CompanyRatingComment.vue';
import CompanyRatingNew from 'JIX/components/CompanyRatingNew.vue';
import CompanyRatingStars from 'JIX/components/CompanyRatingStars.vue';
import SvgIcon from 'JIX/components/SvgIcon.vue';
import { bsTooltip as vBsTooltip } from 'JIX/vue-bs-tooltip.js';
import GaisScoreGraphic from './GaisScoreGraphic.vue';

const newEvaluationModal = ref();

const store = useStore();

const companyName = computed(() => store.state.companyName);
const evaluationData = computed(() => store.state.evaluationData);

function jixAnalytics(label, action) {
    store.dispatch('jixAnalytics', { label, action });
}

function loginCheckRate() {
    checkLogin()
        .then(loginResult => {
            if (loginResult !== LoginResult.ABORTED) {
                setTimeout(function(){
                    newEvaluationModal.value.show();
                }, 300);
            }
        });
}
</script>

<template>
    <div>
        <div class="row">
            <div class="col-md-9">
                <div class="bg-white border p-md-4 mb-4 p-3">
                    <div class="d-flex flex-column flex-md-row align-items-center align-items-md-start">
                        <h3>
                            {{ companyName }}
                        </h3>
                        <div class="mx-auto mr-md-0 d-flex flex-column align-items-center align-items-md-end">
                            <CompanyRatingStars
                                :rating="evaluationData.question2finalrating[0]"
                                size="md"
                                class="mb-3"
                            />
                            <p class="text-sm">
                                {{ T.evaluationCounts(evaluationData.unique_ratings_cnt, evaluationData.rating_data.length) }}
                            </p>
                        </div>
                    </div>
                    <hr class="mt-4">
                    <div class="row">
                        <div
                            v-for="index in [2,5,4,7,3,6]"
                            :key="index"
                            class="col-md-4 text-sm mt-4 h5 mb-0"
                        >
                            {{ T.categoryName(index) }}
                            <SvgIcon
                                v-bs-tooltip="T.categoryTooltip(index)"
                                name="tooltip"
                                size="inline"
                            />
                            <CompanyRatingStars
                                :rating="evaluationData.question2finalrating[index]"
                                size="sm"
                                class="mb-md-2"
                            />
                        </div>
                    </div>
                </div>

                <h3>
                    {{ T.commentsHeader(evaluationData.rating_data.length) }}
                </h3>
                <CompanyRatingComment
                    v-for="(evaluation, index) in evaluationData.rating_data"
                    :key="index"
                    :comment-data="evaluation"
                    :companyname="companyName"
                    :is-adm="store.state.isAdm"
                />
            </div>
            <div class="col-md-3">
                <div class="mb-3 bg-white border p-3">
                    <h5>
                        {{ T.writeEvaluationHeader() }}
                    </h5>
                    <p class="text-sm">
                        {{ T.writeEvaluationExplain(companyName) }}
                    </p>
                    <a
                        @click.prevent="jixAnalytics('evaluer','klik-menu-evalueringer'); loginCheckRate()"
                        class="btn btn-primary w-100 btn-sm"
                    >
                        {{ T.writeEvaluationButton() }}
                    </a>
                </div>
                <div v-if="evaluationData.gais_data !== null" class="mb-3 bg-white border p-0 d-flex">
                    <GaisScoreGraphic
                        :score="evaluationData.gais_data.total_score"
                        class="mx-auto"
                        width="200"
                        height="200"
                    />
                </div>
            </div>
        </div>
        <CompanyRatingNew ref="newEvaluationModal" :proxycompanyid="evaluationData.proxycompanyid" />
    </div>
</template>
